import { IServerDropdownOption, ServerDropdown } from 'components/serverDropdown/ServerDropdown';
import { useGetAllDataSourceLayers } from '../api/useDataSourceLayerController';

interface IDataSourceDropdownProps {
    value: number | null;
    onChange: (value: number | null) => void;
    label?: string;
    disabled?: boolean;
}

export function DataSourceDropdown({ value, onChange, label = 'Data Source', disabled }: IDataSourceDropdownProps) {
    const { data, isLoading } = useGetAllDataSourceLayers();

    const options: IServerDropdownOption<number>[] = (data ?? []).map((item) => ({
        value: item.Id,
        label: item.EnglishTitle,
    }));

    return (
        <ServerDropdown<number>
            value={value}
            onChange={onChange}
            options={options}
            loading={isLoading}
            label={label}
            disabled={disabled}
        />
    );
}
